<template>
  <div>
    <b-toast v-model="isReady" variant="info" id="offline-toast" title="Offline ready!" toaster="b-toaster-top-right">
        <template>
          The current content is ready to be used offline.
      </template>
    </b-toast>
    <div v-if="loading" class="d-flex justify-content-center mb-3">
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <div v-else>
    <b-container id="staticContent" class="pt-4 pt-md-5" v-if="l_esson.content.length">
      <b-row>
        <b-col>
          <div v-for="(content, index) in l_esson.content" :key="index" :class="{'d-none': content && content.type === 'ONLYINTERNALLINK'}">
            <template v-if="content && content.customObject > -1">
              <template v-if="customObjects[content.customObject].parentCustomObject === -1">
                <div v-for="(elem, index1) in content.content" :key="index1">
                  <template v-if="elem && elem.type=='STARTCUSTOM'">
                    <template v-if="customObjects[content.customObject].type=='section'">
                      <section-content
                        :ref="'sec-'+content.customObject.toString() + '-'+index.toString()"
                        :document="document"
                        :lists="lists"
                        :headingParStyles="headingParStyles"
                        :headingTextStyles="headingTextStyles"
                        :customObjects="customObjects"
                        :listsCounter="listsCounter"
                        :l_esson="customObjects[content.customObject]"
                        :customObject="content.customObject"
                        :glossary="glossary"
                        :glossaryUrls="glossaryUrls"
                        :indentifier="index"
                        :name="name"
                        :answerLink="answerLink"
                        :lessonpk="lessonpk"
                        :userId="userId"
                        :id="id"
                        :type="type"
                        @changeSection="changeSection"
                        @listCounterUpdate="listsIndex"
                        @movingto="movingto"
                        @ready="updateDocLoaded"
                      >
                      </section-content>
                    </template>
                    <template v-if="customObjects[content.customObject].type=='collapsable' || customObjects[content.customObject].type === 'collapsible'">
                      <collapsable
                        :ref="'colap-'+content.customObject.toString() + '-'+index.toString()"
                        :document="document"
                        :lists="lists"
                        :getImage="getImage"
                        :headingParStyles="headingParStyles"
                        :headingTextStyles="headingTextStyles"
                        :customObjects="customObjects"
                        :listsCounter="listsCounter"
                        :l_esson="customObjects[content.customObject]"
                        :customObject="content.customObject"
                        :glossary="glossary"
                        :glossaryUrls="glossaryUrls"
                        :name="name"
                        :answerLink="answerLink"
                        :lessonId="lessonpk"
                        :id="id"
                        :userId="userId"
                        :type="type"
                        :nameSectionMenu="l_esson.nameSectionMenu"
                        @changeSection="changeSection"
                        @listCounterUpdate="listsIndex"
                        @movingto="movingto"
                        @ready="updateDocLoaded"
                      />
                    </template>
                  </template>
                </div>
              </template>
            </template>
            <template v-else>
              <headingsContent
                :content="content"
                :getImage="getImage"
                :nameSectionMenu="l_esson.nameSectionMenu"
                :name="name"
                :id="id"
                :lessonpk="id"
                :userId="userId"
                :type="type"
                :customObjects="customObjects"
                :lists="lists"
                :customObject="-1"
                :listsCounter="listsCounter"
                :headingParStyles="headingParStyles"
                :headingTextStyles="headingTextStyles"
                :glossary="glossary"
                :glossaryUrls="glossaryUrls"
                :index="index"
                @listCounterUpdate="listsIndex"
                @changeSection="changeSection"
                @movingto="movingto"
              />
            </template>
          </div>
        </b-col>
      </b-row>
    </b-container>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Collapsable from '@/components/customObjects/Collapsable'
import createJWT from '@/mixins/createJWT'
import parseLessons from '@/mixins/parseLesson'

export default {
  mixins: [createJWT, parseLessons],
  name: 'staticContent',
  data () {
    return {
      type: '',
      documentIdContent: '1JWZDJM1MqEyklu3wjgCjoctwgjvYDDFAEDVeqb-2xU0',
      document: {
        title: '',
        body: {
          content: []
        }
      },
      lists: {},
      loading: true,
      headingParStyles: {},
      headingTextStyles: {},
      lesson: {
        title: [],
        menu: [],
        content: []
      },
      l_esson: {
        content: []
      },
      currentCustomObject: { indent: -1, nesting: -1, parent: null },
      customObjects: [],
      listsCounter: {},
      glossary: [],
      glossaryCount: {},
      glossaryUrls: ['1fVfImk3gdaQIVYVyPNCFBstPnHZOon_NX8MEsx_Lj18'],
      selectedLanguage: 'En',
      languages: {
        En: 1,
        Es: 2
      },
      answerLink: '',
      lessonpk: '',
      userId: null,
      name: '',
      id: null,
      contentCount: 0,
      shouldMakeGlossary: false,
      docLoaded: { root: false },
      isReady: false
    }
  },
  mounted: function () {},
  created: function () {
    this.documentIdContent = (Object.prototype.hasOwnProperty.call(this.$route.params, 'documentid')) ? this.$route.params.documentid : '1JWZDJM1MqEyklu3wjgCjoctwgjvYDDFAEDVeqb-2xU0'
    this.getDocumentContent()
    this.loading = true
  },
  methods: {
    async getDocumentContent () {
      if (window.navigator.onLine) {
        await this.createJwt()
      }
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('gapi.access_token')}` }
      }
      if (!window.navigator.onLine) {
        config.timeout = 2
      }
      await axios.get(process.env.VUE_APP_DOCUMENTS_URL + this.documentIdContent, config).then(async response => {
        this.document = response.data
        await this.$store.commit('addDocument', [process.env.VUE_APP_DOCUMENTS_URL + this.documentIdContent, response.data])
        this.parseDocument(response)
        this.loading = false
        this.docLoaded.root = true
        if (Object.values(this.docLoaded).every(Boolean)) {
          this.isReady = true
        }
      }).catch(async error => {
        console.log(error)
        this.document = await this.$store.state.documents[process.env.VUE_APP_DOCUMENTS_URL + this.documentIdContent]
        if (this.document) {
          this.parseDocument()
        }
        this.loading = false
      })
    },
    tableCellStyle (paddingLeft = 0, paddingRight = 0, paddingTop = 0, paddingBottom = 0, minRowHeight = 0) {
      return {
        'padding-left': `${paddingLeft}pt`,
        'padding-right': `${paddingRight}pt`,
        'padding-bottom': `${paddingBottom}pt`,
        'padding-top': `${paddingTop}pt`,
        'min-height': `${minRowHeight}pt`
      }
    },
    listsIndex (listId, nestingLevel = 0) {
      if (!this.listsCounter[listId]) {
        this.listsCounter[listId] = {}
      }
      if (!this.listsCounter[listId][nestingLevel]) {
        this.listsCounter[listId][nestingLevel] = 0
      }
      this.listsCounter[listId][nestingLevel] += 1
    },
    async getImage (id) {
      if (this.document && this.document.inlineObjects && Object.prototype.hasOwnProperty.call(this.document.inlineObjects, id) && this.document.inlineObjects[id].inlineObjectProperties.embeddedObject.imageProperties) {
        const imageUrl = this.document.inlineObjects[id].inlineObjectProperties.embeddedObject.imageProperties.contentUri
        const base64ImageUrl = btoa(unescape(encodeURIComponent(imageUrl)))
        debugger // eslint-disable-line no-debugger
        try {
          const imageInfo = await axios.get(process.env.VUE_APP_IMAGES_URL + base64ImageUrl)
          return imageInfo.image_url
        } catch (err) {
          console.log(err)
        }
      } else {
        return ''
      }
    },
    changeSection (sectionTitle) {
      const newSectiontitle = sectionTitle[0].toUpperCase() + sectionTitle.slice(1) + '\n'
      this.$refs.secmenu.changeContent(newSectiontitle)
      this.scrollToTop()
    },
    updateDocLoaded (customObject) {
      this.docLoaded[customObject] = true
      if (Object.values(this.docLoaded).every(Boolean)) {
        this.isReady = true
      }
    },
    async movingto (sectionTitle, movetosection, ref, wait = true) {
      const newSectiontitle = sectionTitle[0].toUpperCase() + sectionTitle.slice(1) + '\n'
      this.$refs.secmenu.changeContent(newSectiontitle)
      if (wait) {
        await this.sleep(600)
      }
      this.$root.$emit('Scroll', ref)
      let name = 'Lesson'
      switch (this.type) {
        case 'student':
          name = 'Lesson'
          break
        case 'teachers':
          name = 'teachersLessons'
          break
        case 'blackboard':
          name = 'teachersLessonsBlackBoard'
          break
        case 'projector':
          name = 'teachersLessonsProjector'
          break
        default:
          break
      }
      if (wait) {
        this.$router.push({ name: name, params: { coursesslug: this.$route.params.coursesslug, lessonsslug: this.$route.params.lessonsslug }, query: { section: sectionTitle, internallink: ref } })
      }
    }
  },
  components: {
    Collapsable,
    headingsContent: () => import('@/components/lessonSubElements/headingsContent')
    // 'yellow-box': YellowBox,
    // Quiz,
    // TextAreaQuestion,
    // 'quiz-select': QuizSelect,
    // DragNDrop,
    // Blackboard,
    // Glossary,
    // 'secondary-menu': SecondaryMenu,
    // 'section-content': Section,
    // ExternalDocument,
    // 'teaching-strategies': TeachingStrategies,
    // DialogBox,
    // ExternalWordDocument,
    // DialogBoxLeft,
    // ImageText,
    // ImageTextLeft,
    // ImageLightBlue,
    // 'lesson-nav': lessonNavigation
  }
}
</script>

<style lang="scss" scoped>

</style>
